import React from 'react';
import CustomModal from "../../../components/UI/CustomModal";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import ShopItemDirect from "../../../flowManager/steps/shop/ShopItemDirect";

const ShopItemModal = (props) => {
    const { isOpen, onClose, item, onPurchase } = props;
    const {isMobile} = useScreenSize()

    const onPurchaseClick = (res) => {
        onPurchase(res)
        onClose()
    }

    return (
        <CustomModal open={isOpen} onCancel={onClose} width={isMobile ? 'inherit' : (item.image ? '860px' : '530px')}>
            <ShopItemDirect item={item} onPurchase={onPurchaseClick} isModal={true}/>
        </CustomModal>
    );
};

export default ShopItemModal;